import { FaFilePdf } from 'react-icons/fa6';
import IconAndName from '../../components/IconAndName/IconAndName';
import styles from './LearningJourney.module.css';
import SearchBar from '../../components/SearchBar/SearchBar';
import { BiSolidEdit } from 'react-icons/bi';
import Dropdown from '../../components/Dropdown/Dropdown';
import CheckboxAndData from '../../components/CheckboxAndData/CheckboxAndData';
import { useState } from 'react';
import ActivityListItem from '../../components/ActivityListItem/ActivityListItem';
import CopyRight from '../../components/CopyRight/CopyRight';
import Observations from './Observations/Observations';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';

const LearningJourney = () => {
  const dispatch = useDispatch();
  const [isStaffOnlyChecked, setIsStaffOnlyChecked] = useState(false);
  const [selectedScreen, setSelectedScreen] = useState('UntaggedLessons');

  const [screenContentData, setScreenContentData] = useState([
    {
      label: 'UntaggedLessons',
      color: 'var(--Primary_Color)',
      notificationsCount: 1,
      displayScreen: <Observations />,
    },
    {
      label: 'Physical Development',
      color: 'var(--Error_Color)',
      notificationsCount: 3,
      displayScreen: <Observations />,
    },
    {
      label: 'Maths',
      color: 'var(--Success_Color)',
      notificationsCount: 5,
      displayScreen: <div>Maths</div>,
    },
  ]);
  return (
    <>
      <div className={styles.LearningJourney}>
        <div className={styles.ButtonsContainer}>
          <IconAndName
            title="Save as Draft"
            bgColor="Primary_Color"
            // onClick={ () => console.log('Save as Draft clicked') }
          />
          <IconAndName
            icon={<FaFilePdf />}
            title="Share PDF"
            bgColor="Primary_Color"
            // onClick={ () => console.log('Share PDF clicked') }
          />
        </div>
        <div className={styles.ContentContainer}>
          <div className={styles.ContentHeader}>
            <div className={styles.LeftContentHeader}>
              <SearchBar />
            </div>
            <div className={styles.RightContentHeader}>
              <div
                className={styles.editWrapper}
                onClick={() => console.log('Edit Journey')}
              >
                <BiSolidEdit size={20} />
                <span>This Month</span>
              </div>
              <Dropdown label={'Student'} options={['Staff']} />
              <CheckboxAndData
                label={'Staff Only'}
                labelColor={'rgba(from var(--Black_Color) r g b / 0.6)'}
                labelSize={14}
                checked={isStaffOnlyChecked}
                onChange={() => setIsStaffOnlyChecked(!isStaffOnlyChecked)}
              />
            </div>
          </div>
          <div className={styles.ContentBody}>
            <div className={styles.ContentBodyLeft}>
              <p className={styles.ContentBodyHeading}>Development Area</p>
              {screenContentData.map((item) => (
                <ActivityListItem
                  key={item.label}
                  label={item.label}
                  isActive={selectedScreen === item.label}
                  onClick={() => setSelectedScreen(item.label)}
                  color={item.color || 'var(--Primary_Color)'}
                  notificationsCount={item.notificationsCount}
                />
              ))}
            </div>
            <div className={styles.ContentBodyRight}>
              <div className={styles.ContentBodyHeading}>
                <p className={styles.ContentBodyHeadingText}>
                  {selectedScreen}
                </p>
                <p
                  className={styles.addObservationLink}
                  onClick={() => {
                    dispatch(openModal('addObservation'));
                  }}
                >
                  Add Observation
                </p>
              </div>

              <div className={styles.ContentBodyDisplay}>
                {
                  screenContentData.find(
                    (item) => item.label === selectedScreen
                  )?.displayScreen
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default LearningJourney;
